// @flow

import {useTypedSelector} from '../../../store';

import type {User} from '../../../entities';

export const useUser = (): User | typeof undefined => {
  const user = useTypedSelector(state => state.auth.user);
  return user;
};
